
import {
  Box,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

type MatchSection = {
  title: string;
  matched: boolean;
  matchName?: string;
  matchCount?: number;
  description?: string;
  extraDescription?: string;
  showFamilyInput?: boolean;
  familyName?: string;
};

const sections: MatchSection[] = [
  {
    title: "Fetcher",
    matched: true,
    matchName: "IA None acid",
    matchCount: 9,
    description: "the brand moves to it on save.",
  },
  {
    title: "Unifier",
    matched: false,
    description:
      "No unifier family on IncomeAccess carries this exact set.",
    extraDescription:
      "A new family will be created (POST /families/...) with these maps and the brand connected to it.",
    showFamilyInput: true,
    familyName: "example name wow",
  },
  {
    title: "Advisor",
    matched: true,
    matchName: "IA Second",
    matchCount: 4,
    description: "the brand moves to it on save.",
  },
];

const MatchCard = ({ item }: { item: MatchSection }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 2,
        boxShadow: "none",
        borderColor: item.matched ? "success.light" : "grey.300",
        borderWidth: item.matched ? 1 : 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexWrap: "wrap",
          mb: 0.5,
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 500,
            color: "#000000DE",
          }}
        >
          {item.title}
        </Typography>

        {item.matched ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: "success.main",
            }}
          >
            <CheckIcon sx={{ fontSize: 14 }} />

            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 400,
              }}
            >
              Match Found!
            </Typography>
          </Box>
        ) : (
          <Typography
            sx={{
              fontSize: 12,
              color: "#00000061",
              fontWeight: 400,
            }}
          >
            No Match Found!
          </Typography>
        )}
      </Box>

      {item.matched ? (
        <Typography
          sx={{
            fontSize: 12,
            color: "#00000099",
          }}
        >
          Active set matches{" "}
          <Box
            component="span"
            sx={{
              color: "#00000099",
            }}
          >
            {item.matchName} ({item.matchCount})
          </Box>{" "}
          - {item.description}
        </Typography>
      ) : (
        <>
          <Typography
            sx={{
              fontSize: 12,
              color: "#00000099",
           
            }}
          >
            {item.description}
          </Typography>

          <Typography
            sx={{
              fontSize: 12,
              color: "#00000099",
              mb: item.showFamilyInput ? 2.5 : 0,
            }}
          >
            {item.extraDescription}
          </Typography>

          {item.showFamilyInput && (
            <TextField
              fullWidth
              label="New Family Name"
              color="secondary"
              size="small"
              defaultValue={item.familyName}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1.5,
                  fontSize: 16,
                },

                "& .MuiInputLabel-root": {
                  fontSize: 12,
                },
              }}
            />
          )}
        </>
      )}
    </Paper>
  );
};

export default function SaveChangesModalBodyTwo() {
  return (
    <Box
      sx={{
        width: "100%",
        padding: "16px 24px 20px 24px",
      }}
    >
      {sections.map((item) => (
        <MatchCard key={item.title} item={item} />
      ))}
    </Box>
  );
}